import { summary } from './summary';

export const statistics = {
  summary,
};
